import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { RouterModule } from '@angular/router';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator'; // MatPaginatorModule
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'; // Import BsDatepickerModule
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';


import { CustomInputComponent } from '../CustomInputComponents/custom-input/custom-input.component';
import { CustomSelectComponent } from '../CustomInputComponents/custom-select/custom-select.component';
import { CustomMultiSelectComponent } from '../CustomInputComponents/custom-multi-select/custom-multi-select.component';
import { CustomMultiSelect2Component } from '../CustomInputComponents/custom-multi-select2/custom-multi-select2.component';

@NgModule({
  declarations: [
    CustomInputComponent,
    CustomSelectComponent,
    CustomMultiSelectComponent,
    CustomMultiSelect2Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    CustomInputComponent,
    CustomSelectComponent,
    CustomMultiSelectComponent,
    CustomMultiSelect2Component
  ]
})
export class SharedModule { }
